import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'mprd-flex-emergency-manage-skeleton-pxsplus',
  templateUrl: './flex-emergency-manage-skeleton-pxsplus.component.html',
})
export class FlexEmergencyManageSkeletonPxsplusComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {}

  routeToStep1(): void {
    this.router.navigate(['/pxsplus/flex-emergency-entry']);
  }
}
